{
  "title": "Editar miembro del hogar",
  "client": "Cliente",
  "relationshipTo": "Relación con {{whom}} (miembro principal)",
  "continue": "Continuar",
  "updated": "Se ha actualizado el miembro del hogar {{memberName}}.",
  "save": "Guardar",
  "accessType": "Permisos"
}
